import {
  MAX_SWITCH_IN_ANIMATED_IMAGE_FILE_SIZE,
  MAX_SWITCH_IN_NON_GIF_IMAGE_FILE_SIZE,
} from '@features/campaigns/builder/consts/common.ts';

export function isCreativeSizeValid(file: File[], maxFileSize: number): boolean {
  return file[0].size <= maxFileSize;
}

export function resolveSwitchInMaxFileSize(file: File): number {
  if (file.type === 'image/gif') {
    return MAX_SWITCH_IN_ANIMATED_IMAGE_FILE_SIZE;
  }

  return MAX_SWITCH_IN_NON_GIF_IMAGE_FILE_SIZE;
}
